module.exports = __webpack_public_path__ + "static/media/EastHampton_11.fd3448e5.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/EastHampton_11.JPG
// module id = 230
// module chunks = 0